module.exports = __webpack_public_path__ + "img/10业务领域-img1.3181382c.jpg";